import { SEARCHBOX_ANCHOR_ID } from '../searchConstants';
import getSearchBoxWidth from '../selectors/getSearchBoxWidth';
import SearchScenarioId from '../store/schema/SearchScenarioId';
import { observer } from 'mobx-react';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import * as React from 'react';
import { onResize } from '../actions/internalActions';
import { getGuid } from 'owa-guid';

export interface SearchBoxDropdownProps {
    content: JSX.Element | JSX.Element[];
    id?: string;
    onDismiss?: (evt: any) => void;
    onPositioned?: () => void;
    role?: string;
    scenarioId: SearchScenarioId;
    setInitialFocus: boolean;
    targetId?: string;
}

@observer
export default class SearchBoxDropdown extends React.Component<SearchBoxDropdownProps, {}> {
    render() {
        const { content, scenarioId, id = getGuid(), setInitialFocus } = this.props;

        return (
            <Callout
                calloutWidth={this.getWidth(scenarioId)}
                id={id}
                onDismiss={this.onDismiss}
                onPositioned={this.onPositioned}
                setInitialFocus={setInitialFocus}
                gapSpace={1}
                isBeakVisible={false}
                target={`#${this.getTargetId()}`}>
                {content}
            </Callout>
        );
    }

    /**
     * Update component width once it mounts. This will ensure that the component
     * has the same width as the search box.
     */
    componentDidMount() {
        onResize(document.getElementById(this.getTargetId()).offsetWidth, this.props.scenarioId);
    }

    /**
     * Gets the known width of the search box by checking the store value, or
     * directly accessing the element if the store value hasn't yet been
     * updated.
     */
    private getWidth(scenarioId: SearchScenarioId): number {
        return (
            getSearchBoxWidth(scenarioId) || document.getElementById(this.getTargetId()).offsetWidth
        );
    }

    /**
     * onDismiss callback for the Callout component.
     */
    private onDismiss = (evt: React.MouseEvent<unknown>): void => {
        const { onDismiss } = this.props;

        if (onDismiss) {
            onDismiss(evt);
        }
    };

    /**
     * Gets target ID of which component is mounting on. It's an optional prop,
     * so a default case is set to the anchor div in the SearchBox component.
     */
    private getTargetId(): string {
        return this.props.targetId || SEARCHBOX_ANCHOR_ID;
    }

    /**
     * Callback for when the Callout gets correctly positioned.
     */
    private onPositioned = (): void => {
        if (this.props.onPositioned) {
            this.props.onPositioned();
        }
    };
}
